import { useCallback, useMemo } from 'react'

import type { OfferApi } from '@fourthwall/services/dist/OffersApiClient'

import { useSamplesInfiniteOffersQuery } from '../queries/useSamplesInfiniteOffersQuery'
import { filterOffersWithVariants } from '../utils/filterOffersWithVariants'

export const useSamplesInfiniteOffers = (query?: string) => {
  const { offersInfiniteQuery } = useSamplesInfiniteOffersQuery(query)

  const totalOffers = offersInfiniteQuery.data?.pages.reduce<OfferApi.GetOffersResponse['offers']>(
    (acc, currentOffer) => {
      return [...acc, ...currentOffer.offers]
    },
    [],
  )

  const offers = useMemo(() => filterOffersWithVariants(totalOffers || []), [totalOffers])

  const fetchNextPage = useCallback(() => {
    offersInfiniteQuery.fetchNextPage()
  }, [offersInfiniteQuery])

  return {
    samplesOffers: {
      offers,
      isLoading: offersInfiniteQuery.isLoading,
      hasNextPage: !!offersInfiniteQuery.hasNextPage,
      fetchNextPage,
    },
  }
}
